import { Add, Delete, ExpandMore } from "@mui/icons-material";
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Box,
  Button,
  IconButton,
  Skeleton,
  TextField,
  Typography,
} from "@mui/material";
import CustomContentDialog from "../../../shared/dialog/CustomContentDialog";
import CustomDialog from "../../../shared/dialog/CustomDialog";
import ChecklistItem from "../../project/Checklist/ChecklistItem";
import ChecklistProgress from "../../project/Checklist/ChecklistProgress";
import CustomTrelloInput from "../../project/Checklist/CustomTrelloInput";
import { usePowerDistributionCompanyChecklist } from "./controller";

export const PowerDistributionCompanyChecklist = ({
  pdcId,
  initializeLoadingToast,
  updateLoadingToast,
}) => {
  const {
    templateChecklistLoading,
    templateChecklistData,
    createLoading,
    deleteLoading,
    checklistName,
    itemName,
    handleDeleteChecklist,
    handleCreateChecklist,
    handleCreateItem,
    handleDeleteItem,
    handleSaveChecklist,
    handleSaveChecklistItem,
    createDialogOpen,
    handleCreateDialogOpen,
    handleCreateDialogClose,
    deleteDialogOpen,
    handleDeleteDialogOpen,
    handleDeleteDialogClose,
    createDialogItemOpen,
    handleCreateDialogItemOpen,
    handleCreateDialogItemClose,
    isDisabled
  } = usePowerDistributionCompanyChecklist({
    pdcId,
    initializeLoadingToast,
    updateLoadingToast,
  });

  const renderSkeleton = () => (
    <Box sx={{ width: "100%" }}>
      <Skeleton variant="text" width="40%" height={40} />
      <Box sx={{ mt: 2 }}>
        <Skeleton variant="rectangular" width="100%" height={60} />
        <Box sx={{ mt: 2 }}>
          {[1, 2, 3].map((index) => (
            <Skeleton key={index} variant="rectangular" width="100%" height={40} sx={{ mb: 1 }} />
          ))}
        </Box>
      </Box>
    </Box>
  );

  return (
    <Box sx={{ width: "45%" }}>
      {/* Dialog para criar checklist */}
      <CustomContentDialog
        open={createDialogOpen}
        handleClickClose={handleCreateDialogClose}
        title="Criar Checklist"
        content={
          <TextField
            autoFocus
            margin="dense"
            label="Nome do Checklist"
            fullWidth
            variant="outlined"
            {...checklistName}
          />
        }
        handleConfirmationClick={handleCreateChecklist}
        confirmationClickText="Criar"
        requestLoading={createLoading}
        requestLoadingText="Criando..."
        width={400}
        height={150}
      />

      {/* Dialog para criar item */}
      <CustomContentDialog
        open={createDialogItemOpen}
        handleClickClose={handleCreateDialogItemClose}
        title="Adicionar Item"
        content={
          <CustomTrelloInput
            placeholder="Adicionar item..."
            value={itemName.value}
            onChange={itemName.onChange}
            onClick={(e) => {
              handleCreateItem();
            }}
          />
        }
        handleConfirmationClick={handleCreateItem}
        confirmationClickText="Adicionar"
        requestLoading={createLoading}
        requestLoadingText="Adicionando..."
        width={400}
        height={150}
      />

      {/* Dialog para confirmar exclusão */}
      <CustomDialog
        open={deleteDialogOpen}
        handleClickClose={handleDeleteDialogClose}
        title="Confirmar Exclusão"
        contentText="Tem certeza que deseja excluir este checklist? Esta ação não pode ser desfeita."
        handleConfirmationClick={() => handleDeleteChecklist(templateChecklistData.id)}
        confirmationClickText="Excluir"
        requestLoading={deleteLoading}
        requestLoadingText="Excluindo..."
        width={400}
        height="auto"
      />

      <Accordion>
        <AccordionSummary expandIcon={<ExpandMore />}>
          <Typography>Checklist</Typography>
        </AccordionSummary>
        <AccordionDetails>
          {templateChecklistLoading ? (
            renderSkeleton()
          ) : !templateChecklistData ? (
            <Box>
              <Button
                variant="contained"
                startIcon={<Add />}
                onClick={() => handleCreateDialogOpen()}
                disabled={createLoading}
              >
                Criar Checklist
              </Button>
            </Box>
          ) : (
            <Box>
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  mb: 2,
                }}
              >
                <Typography variant="h6">{templateChecklistData.title}</Typography>
                <IconButton color="error" onClick={handleDeleteDialogOpen} disabled={deleteLoading}>
                  <Delete />
                </IconButton>
              </Box>

              <ChecklistProgress
                total={templateChecklistData.checklistItems.length}
                completed={
                  templateChecklistData.checklistItems.filter((item) => item.isChecked).length
                }
              />

              <Box sx={{ mt: 2 }}>
                {templateChecklistData.checklistItems.map((item) => (
                  <ChecklistItem
                    key={item.id}
                    item={item}
                    onDelete={() => handleDeleteItem(item.id)}
                    onSave={handleSaveChecklistItem}
                  />
                ))}
              </Box>

              <Button
                variant="contained"
                startIcon={<Add />}
                onClick={handleCreateDialogItemOpen}
                disabled={createLoading}
                sx={{ mt: 2 }}
              >
                Adicionar Item
              </Button>
            </Box>
          )}
        </AccordionDetails>
      </Accordion>
    </Box>
  );
};
